import { DuplicateChannelNameError } from '@/shared/domain'
import { mapConnectError } from './map-connect-error'

export function mapChannelAdminError(error: unknown): Error {
  if (error instanceof Error && error.message.toLowerCase().includes('http 409')) {
    return new DuplicateChannelNameError()
  }
  return mapConnectError(error)
}
